export const objectDefault = {
  // hc_id: 4,

  hc_categoria: "",
  hc_parametro: "",
  hc_usuario: "",
  hc_empresa: "",
  hc_fec_reg: "",
};

// "hc_id": 1,
// 				"hc_categoria": null,
// 				"hc_parametro": "TP",
// 				"hc_usuario": "admin",
// 				"hc_empresa": "DEMO",
// 				"hc_fec_reg": "2025-06-06T17:35:33.000Z"


export const columns = [
  // {
  //   id: "hc_categoria",
  //   label: "Categoria",
  //   minWidth: 25,
  //   tipo: "string",
  //   propiedad: "hc_categoria",
  // },
  {
    id: "hc_parametro",
    label: "Parametro",
    minWidth: 25,
    tipo: "string",
    propiedad: "hc_parametro",
  },
  {
    id: "hc_usuario",
    label: "User",
    minWidth: 25,
    tipo: "string",
    propiedad: "hc_usuario",
  },
  {
    id: "hc_fec_reg",
    label: "Fec. Reg.",
    minWidth: 25,
    tipo: "string",
    propiedad: "hc_fec_reg",
  },
];
